import { didCancel } from 'ember-concurrency';

export default function throwUnlessTaskDidCancel(error) {
  if (!didCancel(error)) {
    throw error;
  }
}
